import { FC } from "react";
import { icons } from "../../icons/IconSet";
import { useTicket } from "../../hooks/useTicket";

const NotificationWidget: FC = () => {
  const { refreshAllTickets } = useTicket();

  return (
    <div className="w-[40px] flex items-center justify-right gap-2">
      <div
        role="button"
        tabIndex={-1}
        onClick={() => refreshAllTickets()}
        className=""
      >
        {icons('refresh')}
      </div>
    </div>
  );
}

export default NotificationWidget;
